import React from 'react'
import single from '../../assets/images/blog/single.jpg';
import image from '../../assets/images/avatar/1.jpg';
import Navbar from '../../components/navbar'
import Footer from '../../components/footer';
import Switcher from '../../components/switcher';
import { Link, useParams } from 'react-router-dom';
import DiscoverItems from '../../components/discover-items';
import { data } from '../../data/data';

export default function CreatorProfile() {
    const params = useParams();
    const id = params.id
    const creater = data.find((creatorr) => creatorr.id === parseInt (id));

    const loadFile = (event) => {
        const image = document.getElementById(event.target.name);
        image.src = URL.createObjectURL(event.target.files[0]);
    };

    return (
        <>
            <Navbar />

            <section className="relative md:pb-24 pb-16 lg:mt-24 mt-[74px]">
                <div className="lg:container container-fluid">
                    <div className="group profile-banner relative overflow-hidden text-transparent lg:rounded-xl shadow dark:shadow-gray-700">
                        <input id="pro-banner" name="profile-banner" type="file" className="hidden" onChange={loadFile} />
                        <div className="relative shrink-0">
                            <img src={single} className="h-80 w-full object-cover" id="profile-banner" alt="" />
                            <div className="absolute inset-0 bg-slate/10 group-hover:bg-slate-900/40 transition duration-500" /></div>
                        <label className="absolute inset-0 cursor-pointer" htmlFor="pro-banner"></label>
                    </div>
                </div>

                <div className="md:flex justify-center">
                    <div className="md:w-full">
                        <div className="relative -mt-[60px] text-center">
                            <div className="group profile-pic w-[112px] mx-auto">
                                <input id="pro-img" name="profile-image" type="file" className="hidden" onChange={loadFile} />
                                <div>
                                    <div className="relative w-28 mx-auto rounded-full shadow dark:shadow-gray-800 ring-4 ring-slate-50 dark:ring-slate-800 overflow-hidden">
                                        <img src={creater?.avatar ? creater?.avatar : image} className="rounded-full" id="profile-image" alt="" />
                                        <div className="absolute inset-0 group-hover:bg-slate-900/40 transition duration-500"></div>
                                        <label className="absolute inset-0 cursor-pointer" htmlFor="pro-img"></label>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-6">
                                <h5 className="text-xl font-semibold">{creater?.name ? creater?.name : "Jenny Jimenez"} <i className="mdi mdi-check-decagram text-emerald-600 align-middle text-lg"></i></h5>
                                <p className="text-slate-400 text-[16px] mt-1">Created by <Link to="/" className="text-tone font-semibold">1x5484dcdvcdscds56c4</Link></p>

                                <div className="mt-4">
                                    <Link to="#" className="btn btn-sm rounded-full bg-tone hover:bg-hover-tone border-tone hover:border-hover-tone text-white mx-1"><i className="mdi mdi-plus"></i> Follow me</Link>
                                    <Link to="#" className="btn btn-icon btn-sm rounded-full bg-tone hover:bg-hover-tone border-tone hover:border-hover-tone text-white mx-1"><i className="mdi mdi-account-plus"></i></Link>
                                    <Link to="/creator-profile-edit" className="btn btn-icon btn-sm rounded-full bg-tone/5 hover:bg-tone border-tone/10 hover:border-tone text-tone hover:text-white mx-1"><i className="mdi mdi-cog"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DiscoverItems/>
            </section>
            <Footer />
            <Switcher />
        </>
    )
}
